/* eslint-disable camelcase */
import { isBoolean, isNumber, isString, isObject } from 'typechecker'
import Car from '@/classes/Car'
import CarSource from '@/enums/CarSource'

const { isArray } = Array

export type Id = number
export type Age = number
export type Seats = number | string | undefined
export type CarImage = string
export type IsDomestic = boolean
export type Insurance = {
  required: string,
  coverage: string,
  unit_charge: string,
  unit: string,
  currency_code: string,
  include_in_rate: string
}
export type Fee = {
  Purpose: string
  Description: string
  IncludedInRate: string
  Amount: string
  CurrencyCode: string
}

/** 車輛 */
export default class HertzCar {
  source: CarSource = CarSource.HERTZ
  key: Symbol = Symbol('')
  /** 所謂的 Car ID */
  id?: Id

  /** 是否含冷氣 */
  airCondition?: string
  /** 車齡 */
  age?: number
  /** 行李 */
  baggage?: string
  category?: string
  carRate?: string
  /** 幣種 */
  currency?: string
  /** 門 */
  doors?: number
  /**  */
  exhaust?: number
  /** 設備 */
  features?: string[]
  fuelType?: string
  /** 照片 */
  images?: string[]
  /** 保險 */
  insurances?: Insurance[]
  /** 是否國產 */
  isDomestic?: boolean
  /** 超里程費用 */
  mileagePolicy?: object
  /** 車款 */
  model?: string
  /** 初始價錢 */
  originalPrice?: number
  /** 價錢 */
  price?: number
  /** 座位數 */
  seats?: Seats
  /** 國際租車標準 */
  SIPP?: string
  /** 大小 */
  size?: string
  tax?: string
  /** 排檔 */
  transmission?: string
  /** 車型 */
  type?: string
  fee?: Array<Fee>

  carReferenceId?: string
  constructor (car: {
    id?: Id | null
    age?: number | null
    carRate?: string
    currency?: string
    price?: number
    originalPrice?: number
    model?: string
    tax?: string
    type?: string
    transmission?: string
    doors?: number
    exhaust?: number | null
    features?: string[]
    insurances?: Insurance[]
    isDomestic?: boolean
    images?: string[]
    seats?: Seats
    SIPP?: string
    airCondition?: string
    fuelType?: string
    mileagePolicy?: object
    baggage?: string
    size?: string
    category?: string
    carReferenceId?: string
    fee?: Array<Fee>
    }) {
    if (!isObject(car)) throw new TypeError('`car` must be an object!')

    if (isNumber(car.age)) this.age = car.age!
    if (isString(car.currency)) this.currency = car.currency
    if (isString(car.carRate)) this.carRate = car.carRate
    if (isNumber(car.price)) this.price = car.price
    if (isNumber(car.originalPrice)) this.originalPrice = car.originalPrice
    if (car.model && isString(car.model)) this.model = car.model.toLowerCase().charAt(0).toUpperCase() + car.model.toLowerCase().slice(1)
    if (isString(car.tax)) this.tax = car.tax
    if (isString(car.type)) this.type = car.type
    if (isString(car.transmission)) this.transmission = car.transmission
    if (isNumber(car.doors)) this.doors = car.doors
    if (isNumber(car.exhaust)) this.exhaust = car.exhaust!
    if (isArray(car.features)) this.features = car.features
    if (isArray(car.insurances)) this.insurances = car.insurances
    if (isBoolean(car.isDomestic)) this.isDomestic = car.isDomestic
    if (isArray(car.images)) this.images = car.images
    if (isString(car.seats) || isNumber(car.seats)) {
      this.seats = car.seats
    } else throw new TypeError('`car.seats` must be a number!')
    if (isString(car.SIPP)) this.SIPP = car.SIPP
    if (isString(car.airCondition)) this.airCondition = car.airCondition
    if (isString(car.fuelType)) this.fuelType = car.fuelType
    if (isObject(car.mileagePolicy)) this.mileagePolicy = car.mileagePolicy
    if (isString(car.baggage)) this.baggage = car.baggage
    if (isString(car.size)) this.size = car.size
    if (isString(car.category)) this.category = car.category
    if (isString(car.carReferenceId)) this.carReferenceId = car.carReferenceId
    if (isArray(car.fee)) this.fee = car.fee
  }

  /** 至 Confirm 頁的連結 */
  get link () {
    return `/car/confirm/${this.id}`
  }
}

export const isHertzCar = (value: Car | HertzCar | null): value is HertzCar => {
  return value?.source === CarSource.HERTZ
}
